module.exports = __webpack_public_path__ + "static/media/icon-balloon-updates.5191fa53.svg";